/**
 * The Grow settings the app reads, as the owner last saved them in the
 * backend's Grow Settings panel (admin/grow-settings.html).
 *
 * See the backend's routes/growSettings.js: GET /api/grow-settings, open to
 * anyone, since none of these is secret. Only the app's own sections come
 * back (Today, Photos, Welcome, Weather wording, Sharing), by their full keys.
 * The store that keeps them, and their defaults, is shared/lib/growSettings.
 *
 * Endpoint: GET /grow-settings → { success, values: { [fullKey]: unknown } }.
 * No sign-in needed. Asked as the app starts (lib/growSettings
 * loadGrowSettings, from main.tsx) and again when a tab becomes visible, at
 * most every five minutes (rereadGrowSettingsWhenVisible); not a React Query, so a change reaches
 * the app on its next re-read, open or reload.
 *
 * @module api/growSettings
 */

import { apiClient } from './apiClient';

/** What GET /api/grow-settings answers: each setting by its full key ("today.RAIN_MONTH_OPENS"). */
interface GrowSettingsResponse {
  success: boolean;
  values: Record<string, unknown>;
}

/**
 * The app's settings as saved, unchecked: the store checks each against its default.
 *
 * @returns Each setting by its full key.
 */
export async function getGrowSettings(): Promise<Record<string, unknown>> {
  const response = await apiClient.get<GrowSettingsResponse>('/grow-settings');
  return response.data?.values ?? {};
}
